export default function filter(){
    if(document.querySelector(".filter__clear")){
        let clearFilter = document.querySelector(".filter__clear");
        let options = document.querySelectorAll(".listing__option input");
        let openFilter = document.querySelector(".listing__open");
        let sidebar = document.querySelector(".listing__sidebar");

        clearFilter.addEventListener("click", () => {
            options.forEach(el => {
                el.checked = false;
            });
        });

        openFilter.addEventListener("click", () => {
            sidebar.classList.toggle("active");
        })
    }
}